import themeConfig from '@configs/themeConfig'
import {LayoutData} from '@src/store/layout/type'

export const initialData: LayoutData = {
  isRTL: themeConfig.layout.isRTL,
  menuCollapsed: themeConfig.layout.menu.isCollapsed,
  skin: themeConfig.layout.skin
}
